import React from "react";
import siteText from "../assets/siteText.json";
import { buildSrcSets, defaultSizes } from "../utils/imageSrcSet";

// Each base corresponds to files produced by scripts/optimize-images.mjs
// and located under public/images/optimized/<base>-w{width}.(webp|jpg)
const images = [
  { base: "IMG_2862", alt: "Fig Tree Cottage - Exterior", widths: [480] },
  { base: "Fig-Tree-Cottage-Front", alt: "Cottage Front" },
  { base: "PXL_20240401_073359261~2", alt: "Cottage Garden View" },
  { base: "PXL_20240401_131531191", alt: "Living Room" },
  { base: "Fig-Tree-Conservatory-Breakfast-Bar", alt: "Conservatory Breakfast Bar" },
  { base: "Fig-Tree-Conservatory-Dining", alt: "Conservatory Dining Area" },
  { base: "PXL_20240416_140557684", alt: "Kitchen" },
  { base: "PXL_20240416_140713373", alt: "Bathroom" },
  { base: "PXL_20240416_141720906", alt: "Garden Seating" },
  { base: "PXL_20240416_142050190.MP", alt: "Nearby Countryside" },
  { base: "image1", alt: "Corfe Castle View", widths: [480] },
  { base: "Fig-Tree-Single-Bedroom", alt: "Single Bedroom" }
];

function Gallery() {
  return (
    <div className="container">
      <h2>{siteText.gallery.header}</h2>
      <div style={{ display: "flex", flexWrap: "wrap", gap: "1.5rem", justifyContent: "center" }}>
        {images.map((img, idx) => {
          const { srcSetWebp, srcSetJpg } = buildSrcSets(img.base, img.widths);
          const fallbackWidth = img.widths ? img.widths[0] : 768;
          const fallback = `${process.env.PUBLIC_URL || ''}/images/optimized/${img.base}-w${fallbackWidth}.jpg`;
          return (
            <div key={idx} style={{ width: 320, maxWidth: "100%" }}>
              <div style={{ position: "relative", width: "100%", paddingTop: "66.666%", borderRadius: 10, overflow: "hidden", boxShadow: "0 2px 8px rgba(0,0,0,0.15)" }}>
                <picture>
                  <source type="image/webp" srcSet={srcSetWebp} sizes={defaultSizes} />
                  <source type="image/jpeg" srcSet={srcSetJpg} sizes={defaultSizes} />
                  <img
                    src={fallback}
                    alt={img.alt}
                    width={320}
                    height={213}
                    loading="lazy"
                    decoding="async"
                    referrerPolicy="no-referrer"
                    style={{ position: "absolute", inset: 0, width: "100%", height: "100%", objectFit: "cover", display: "block" }}
                  />
                </picture>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default Gallery;
